export default __webpack_public_path__ + "static/emp-icn14-2cb87e7f14c4c4a6edebb0916a7520d8.png";